import { TicketsIcon } from "app/components/Icons";
import LazyImage from "app/components/LazyImage";
import LetterCard from "app/components/LetterCard";
import ReactIcon from "app/components/ReactIcon";
import { IWorkspaceTeams } from "app/types";
import clsx from "clsx";
import React, { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getInitials } from "utils/helpers";
import { IAvatar } from "../containers/TeamSettings/container/MySetting/types";
import { selectSelectedTeam } from "app/redux/selector";
import { useSelector } from "react-redux";
import { projectLink } from "app/data";
import { getProjectLinkIcon } from "app/components/Sidebar/helper";

export default function Breadcrumb() {
  const { project } = useParams<{ project: string }>();
  const selectedTeam = useSelector(selectSelectedTeam);

  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const currentRouteLink = pathSegments[pathSegments.length - 1];
  const projects = useMemo(
    () => selectedTeam?.projects?.find((p) => p?._id === project),
    [selectedTeam, project],
  );

  const currentProjectLink = projectLink.find(
    (item) => item.link === currentRouteLink,
  );
  const breadcrumbName = currentProjectLink?.name ?? "Tickets";
  const breadcrumbIcon = currentProjectLink?.icon ?? "tickets";
  const teamName = selectedTeam?.teamName ?? "Unnamed Team";
  const avatar = selectedTeam?.avatar ?? ({} as IAvatar);

  const renderLetter = (avatar: IAvatar, name: string) => {
    if (avatar?.file) {
      return (
        <LazyImage
          src={avatar.file}
          alt={name}
          className="size-[12px] object-cover"
        />
      );
    }
    if (avatar?.icon) {
      return <ReactIcon icon={avatar.icon} />;
    }

    return getInitials(name);
  };

  return (
    <div className="flex flex-row items-center gap-[6px] min-w-max px-[24px]">
      <div className="flex flex-row items-center gap-[6px]">
        {/* Team Avatar */}
        <LetterCard
          className="!size-[16px] !min-w-[16px] !min-h-[16px]"
          letterClassName="!text-secondary text-[8px] leading-[12px]"
          letter={renderLetter(avatar, teamName)}
          backgroundColor={avatar?.color ?? "#D9D9D9"}
        />
        <span className="text-sm text-secondary font-normal">{teamName}</span>

        <span className="text-sm font-normal text-secondary">/</span>

        {/* Project Avatar */}
        {projects && (
          <>
            <LetterCard
              className="!size-[16px] !min-w-[16px] !min-h-[16px]"
              letterClassName="!text-secondary text-[8px] leading-[12px]"
              letter={renderLetter(
                projects.avatar as IAvatar,
                projects.projectName,
              )}
              backgroundColor={projects.avatar?.color ?? "#D9D9D9"}
              color="#79808A"
            />
            <span className="text-sm text-secondary font-normal">
              {projects.projectName}
            </span>
            <span className="text-sm font-normal text-secondary">/</span>
          </>
        )}

        {/* Current Page Icon + Name */}
        <div className="flex flex-row items-center gap-[6px]">
          {getProjectLinkIcon(breadcrumbIcon)}
          <span className="text-sm text-black font-medium">
            {breadcrumbName}
          </span>
        </div>
      </div>
    </div>
  );
}
